<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Report Pembinaan Grade",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Pagination,
  },
  data() {
    // Get hak akses
    const menu = "Report Pembinaan Grade";
    return {
      header: [],
      headerEnabler: [],
      activeTab: "tab1",
      title: menu,
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      isLoading: true,
      isLoadingEnabler: true,
      isLoadingSummary: true,
      tableData: [],
      kode: "",
      batch: "",
      tableFilter: {
        page: 1,
        per_page: 10,
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      tableDataEnabler: [],
      tableFilterEnabler: {
        page: 1,
        per_page: 10,
      },
      paginationEnabler: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      tableDataSummary: [],
      tableFilterSummary: {
        page: 1,
        per_page: 10,
      },
      paginationSummary: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      isGenerate: false,
      dataJadwal: [],
      isShow: false,
    };
  },
  async mounted() {},
  methods: {
    async getData(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.tableFilter.kode = this.kode;
      this.tableFilter.batch = this.batch;
      this.isLoading = true;
      const data = await axios({
        methods: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "report-pembinaan-grade/get-core-pack",
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        params: this.tableFilter,
      })
        .then((response) => response.data)
        .catch((err) => {
          let errResponse = err.response.data;
          if (errResponse.meta?.code == 403) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: errResponse.meta.message,
            });
            this.$router.push({ name: "logout" });
            return false;
          }
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: errResponse.data,
          });

          console.log(errResponse);
          return false;
        });
      if (data) {
        if (data.meta.code == 403) {
          this.$router.push("logout");
        } else if (data.meta.code == 200) {
          this.header = data.data.data.header;
          console.log(this.header.length);
          this.tableData = data.data.data.result.data.map((item) => {
            return {
              ...item,
              cols: item.cols ? JSON.parse(item.cols) : {}, // parse string jadi object
            };
          });
          this.pagination.lastPage = data.data.data.result.last_page;
          this.pagination.currentPage = data.data.data.result.current_page;
          this.pagination.total = data.data.data.result.total;
          this.pagination.lastPageUrl = data.data.data.result.last_page_url;
          this.pagination.nextPageUrl = data.data.data.result.next_page_url;
          this.pagination.prevPageUrl = data.data.data.result.prev_page_url;
          this.pagination.from = data.data.data.result.from;
          this.pagination.to = data.data.data.result.to;
          this.pagination.links = data.data.data.result.links;
        }
      }
      this.isLoading = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getData(false);
    },
    exportData() {
      let params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/report-pembinaan/export-core?" +
          params
      );
    },
    async getDataEnabler(resetPage = true) {
      this.tableFilterEnabler.page = resetPage
        ? 1
        : this.tableFilterEnabler.page;
      this.tableFilterEnabler.kode = this.kode;
      this.tableFilterEnabler.batch = this.batch;
      this.isLoadingEnabler = true;
      const data = await axios({
        methods: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "report-pembinaan-grade/get-enabler-pack",
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        params: this.tableFilterEnabler,
      })
        .then((response) => response.data)
        .catch((err) => {
          let errResponse = err.response.data;
          if (errResponse.meta?.code == 403) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: errResponse.meta.message,
            });
            this.$router.push({ name: "logout" });
            return false;
          }
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: errResponse.data,
          });

          console.log(errResponse);
          return false;
        });
      if (data) {
        if (data.meta.code == 403) {
          this.$router.push("logout");
        } else if (data.meta.code == 200) {
          this.headerEnabler = data.data.data.header;
          this.tableDataEnabler = data.data.data.result.data.map((item) => {
            return {
              ...item,
              cols: item.cols ? JSON.parse(item.cols) : {}, // parse string jadi object
            };
          });
          this.paginationEnabler.lastPage = data.data.data.result.last_page;
          this.paginationEnabler.currentPage =
            data.data.data.result.current_page;
          this.paginationEnabler.total = data.data.data.result.total;
          this.paginationEnabler.lastPageUrl =
            data.data.data.result.last_page_url;
          this.paginationEnabler.nextPageUrl =
            data.data.data.result.next_page_url;
          this.paginationEnabler.prevPageUrl =
            data.data.data.result.prev_page_url;
          this.paginationEnabler.from = data.data.data.result.from;
          this.paginationEnabler.to = data.data.data.result.to;
          this.paginationEnabler.links = data.data.data.result.links;
        }
      }
      this.isLoadingEnabler = false;
    },
    toPageEnabler(url) {
      let link = new URLSearchParams(url);
      this.tableFilterEnabler.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataEnabler(false);
    },
    exportDataEnabler() {
      let params = new URLSearchParams(this.tableFilterEnabler).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/report-pembinaan/export-enabler?" +
          params
      );
    },
    async getDataSummary(resetPage = true) {
      this.tableFilterSummary.page = resetPage
        ? 1
        : this.tableFilterSummary.page;
      this.tableFilterSummary.kode = this.kode;
      this.tableFilterSummary.batch = this.batch;
      this.isLoadingSummary = true;
      const data = await axios({
        methods: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "report-pembinaan-grade/get-summary",
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        params: this.tableFilterSummary,
      })
        .then((response) => response.data)
        .catch((err) => {
          let errResponse = err.response.data;
          if (errResponse.meta?.code == 403) {
            Swal.fire({
              icon: "error",
              title: "Terjadi Kesalahan",
              text: errResponse.meta.message,
            });
            this.$router.push({ name: "logout" });
            return false;
          }
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text: errResponse.data,
          });

          console.log(errResponse);
          return false;
        });
      if (data) {
        if (data.meta.code == 403) {
          this.$router.push("logout");
        } else if (data.meta.code == 200) {
          this.tableDataSummary = data.data.data.map((item) => {
            return {
              ...item,
              cols: item.cols ? JSON.parse(item.cols) : {}, // parse string jadi object
            };
          });
          this.paginationSummary.lastPage = data.data.last_page;
          this.paginationSummary.currentPage = data.data.current_page;
          this.paginationSummary.total = data.data.total;
          this.paginationSummary.lastPageUrl = data.data.last_page_url;
          this.paginationSummary.nextPageUrl = data.data.next_page_url;
          this.paginationSummary.prevPageUrl = data.data.prev_page_url;
          this.paginationSummary.from = data.data.from;
          this.paginationSummary.to = data.data.to;
          this.paginationSummary.links = data.data.links;
        }
      }
      this.isLoadingSummary = false;
    },
    toPageSummary(url) {
      let link = new URLSearchParams(url);
      this.tableFilterSummary.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataSummary(false);
    },
    exportDataSummary() {
      let params = new URLSearchParams(this.tableFilterSummary).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/report-pembinaan/export-summary?" +
          params
      );
    },
    generateReport() {
      this.isShow = false;
      this.getDetailBatch();
      this.tableData = [];
      this.tableFilter = {
        page: 1,
        per_page: 10,
      };
      this.pagination = {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      };
      this.tableDataEnabler = [];
      this.tableFilterEnabler = {
        page: 1,
        per_page: 10,
      };
      this.paginationEnabler = {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      };
      this.tableDataSummary = [];
      this.tableFilterSummary = {
        page: 1,
        per_page: 10,
      };
      this.paginationSummary = {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      };
      this.getData();
      this.getDataEnabler();
      this.getDataSummary();
      this.isGenerate = true;
    },
    async getDetailBatch() {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "report-pembinaan-grade/get-detail-batch/" +
        this.batch +
        "/" +
        this.kode;
      const config = {
        method: "get",
        url: url,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };

      try {
        const response = axios(config);
        const responseData = await response;

        if (responseData.data.meta.code === 200) {
          self.dataJadwal = responseData.data.data;
          self.isShow = true;
        } else {
          // throw new Error(responseData.message);
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });

        throw error;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="col-md-12">
              <div class="alert alert-info" role="alert">
                <h5 class="alert-heading">Info!</h5>
                <p>
                  Report Pembinaan Grade menampilkan hasil asesmen peserta
                  berdasarkan Kode Tes dan Batch yang dipilih. Silakan masukkan
                  Kode Tes dan Batch yang diinginkan, lalu klik tombol "Generate
                  Report" untuk melihat hasil asesmen peserta.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="col-md-12">
              <hr />
              <div class="row">
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="filterKodeTes">Kode Tes</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Kode Tes"
                      v-model="kode"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="filterBatch">Batch</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Batch"
                      v-model="batch"
                    />
                  </div>
                </div>

                <div class="col-md-2 d-flex align-items-end">
                  <button class="btn btn-primary w-100" @click="generateReport">
                    Generate Report
                  </button>
                </div>
                <div v-if="isShow">
                  <hr />
                  <div>
                    <h4>Informasi Jadwal</h4>
                    <table border="0">
                      <tr>
                        <td><b>Kode Tes</b></td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{{ dataJadwal?.jadwal?.kode_tes }}</td>
                      </tr>
                      <tr>
                        <td><b>Keterangan</b></td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{{ dataJadwal?.keterangan }}</td>
                      </tr>
                      <tr>
                        <td><b>Batch</b></td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{{ dataJadwal?.nama_batch }}</td>
                      </tr>
                      <tr>
                        <td><b>Waktu Mulai</b></td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{{ dataJadwal?.waktu_mulai }}</td>
                      </tr>
                      <tr>
                        <td><b>Waktu Selesai</b></td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>{{ dataJadwal?.waktu_selesai }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <hr />
            </div>
            <!-- Tabs -->
            <template v-if="isGenerate">
              <ul class="nav nav-tabs" id="reportTabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'tab1' }"
                    @click="activeTab = 'tab1'"
                  >
                    Core Pack
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'tab2' }"
                    @click="activeTab = 'tab2'"
                  >
                    Enabler Pack
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === 'tab3' }"
                    @click="activeTab = 'tab3'"
                  >
                    Summary
                  </button>
                </li>
              </ul>

              <div class="tab-content mt-3">
                <!-- TAB 1 -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'tab1' }"
                >
                  <div class="d-flex justify-content-between mb-2">
                    <div class="card-title">Report Core Pack</div>
                    <button
                      class="btn btn-sm btn-success"
                      @click="exportData('tab1')"
                      v-if="isWrite == 1"
                    >
                      Export Core Pack Peserta
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <table>
                        <tr>
                          <td>Show</td>
                          <td>
                            <select
                              class="form-control form-control-sm"
                              id="showpaginatetable"
                              style="width: 100%"
                              v-model="tableFilter.per_page"
                              @change="getData()"
                            >
                              <option value="10" selected>10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="200">200</option>
                              <option value="500">500</option>
                            </select>
                          </td>
                          <td>Entries</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table mb-0 table-bordered table-condensed table-hover"
                    >
                      <thead
                        class="bg-dark text-center text-white align-middle"
                      >
                        <tr>
                          <th rowspan="3">No</th>
                          <th rowspan="3">Nama</th>
                          <th rowspan="3">NIP</th>
                          <th rowspan="3">Kode Tes</th>
                          <th rowspan="3">Batch</th>
                          <th :colspan="header.length * 4">Core Pack</th>
                        </tr>
                        <tr>
                          <th
                            v-for="(row, index) in header"
                            :key="index"
                            colspan="4"
                          >
                            {{ row.nama }}
                          </th>
                        </tr>
                        <tr>
                          <template v-for="(row, index) in header" :key="index">
                            <th>LEVEL</th>
                            <th>KKJ</th>
                            <th>UJI</th>
                            <th>KET</th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="isLoading">
                          <td colspan="15" class="text-center">
                            <i class="fas fa-spinner fa-spin"></i> Loading...
                          </td>
                        </tr>
                        <tr v-else-if="tableData.length === 0">
                          <td class="text-center" colspan="99">
                            Data Tidak Tersedia
                          </td>
                        </tr>
                        <tr
                          v-else
                          v-for="(row, index) in tableData"
                          :key="index"
                        >
                          <td class="text-center">
                            {{ index + pagination.from }}
                          </td>
                          <td class="text-center">{{ row.nama }}</td>
                          <td class="text-center">{{ row.nip }}</td>
                          <td class="text-center">{{ tableFilter.kode }}</td>
                          <td class="text-center">{{ tableFilter.batch }}</td>
                          <template
                            v-for="(rowHead, indexHead) in header"
                            :key="indexHead"
                          >
                            <td class="text-center">
                              {{
                                row.cols[
                                  "LEVEL_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                row.cols[
                                  "KKJ_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                row.cols[
                                  "UJI_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                row.cols[
                                  "KET_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <pagination :pagination="pagination" @to-page="toPage" />
                </div>

                <!-- TAB 2 -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'tab2' }"
                >
                  <div class="d-flex justify-content-between mb-2">
                    <div class="card-title">Report Enabler Pack</div>
                    <button
                      class="btn btn-sm btn-success"
                      @click="exportDataEnabler('tab2')"
                      v-if="isWrite == 1"
                    >
                      Export Enabler Pack Peserta
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <table>
                        <tr>
                          <td>Show</td>
                          <td>
                            <select
                              class="form-control form-control-sm"
                              id="showpaginatetable"
                              style="width: 100%"
                              v-model="tableFilterEnabler.per_page"
                              @change="getData()"
                            >
                              <option value="10" selected>10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="200">200</option>
                              <option value="500">500</option>
                            </select>
                          </td>
                          <td>Entries</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table mb-0 table-bordered table-condensed table-hover"
                    >
                      <thead
                        class="bg-dark text-center text-white align-middle"
                      >
                        <tr>
                          <th rowspan="3">No</th>
                          <th rowspan="3">Nama</th>
                          <th rowspan="3">NIP</th>
                          <th rowspan="3">Kode Tes</th>
                          <th rowspan="3">Batch</th>
                          <th :colspan="headerEnabler.length * 4">
                            Enabler Pack
                          </th>
                        </tr>
                        <tr>
                          <th
                            v-for="(row, index) in headerEnabler"
                            :key="index"
                            colspan="4"
                          >
                            {{ row.nama_kompetensi }}
                          </th>
                        </tr>
                        <tr>
                          <template
                            v-for="(row, index) in headerEnabler"
                            :key="index"
                          >
                            <th>LEVEL</th>
                            <th>KKJ</th>
                            <th>UJI</th>
                            <th>KET</th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="isLoadingEnabler">
                          <td colspan="15" class="text-center">
                            <i class="fas fa-spinner fa-spin"></i> Loading...
                          </td>
                        </tr>
                        <tr v-else-if="tableData.length === 0">
                          <td class="text-center" colspan="99">
                            Data Tidak Tersedia
                          </td>
                        </tr>
                        <tr
                          v-else
                          v-for="(row, index) in tableDataEnabler"
                          :key="index"
                        >
                          <td class="text-center">
                            {{ index + paginationEnabler.from }}
                          </td>
                          <td class="text-center">{{ row.nama }}</td>
                          <td class="text-center">{{ row.nip }}</td>
                          <td class="text-center">
                            {{ tableFilterEnabler.kode }}
                          </td>
                          <td class="text-center">
                            {{ tableFilterEnabler.batch }}
                          </td>
                          <template
                            v-for="(rowHead, indexHead) in headerEnabler"
                            :key="indexHead"
                          >
                            <td class="text-center">
                              {{
                                row.cols[
                                  "LEVEL_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                row.cols[
                                  "KKJ_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                row.cols[
                                  "UJI_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                            <td class="text-center">
                              {{
                                row.cols[
                                  "KET_" +
                                    rowHead.idkompetensi +
                                    "_" +
                                    rowHead.level
                                ] ?? "-"
                              }}
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <pagination
                    :pagination="paginationEnabler"
                    @to-page="toPageEnabler"
                  />
                </div>

                <!-- TAB 3 -->
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'tab3' }"
                >
                  <div class="d-flex justify-content-between mb-2">
                    <div class="card-title">Report Summary</div>
                    <button
                      class="btn btn-sm btn-success"
                      @click="exportDataSummary('tab3')"
                      v-if="isWrite == 1"
                    >
                      Export Summary
                    </button>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <table>
                        <tr>
                          <td>Show</td>
                          <td>
                            <select
                              class="form-control form-control-sm"
                              id="showpaginatetable"
                              style="width: 100%"
                              v-model="tableFilterEnabler.per_page"
                              @change="getData()"
                            >
                              <option value="10" selected>10</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="200">200</option>
                              <option value="500">500</option>
                            </select>
                          </td>
                          <td>Entries</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table mb-0 table-bordered table-condensed table-hover"
                    >
                      <thead
                        class="bg-dark text-center text-white align-middle"
                      >
                        <tr>
                          <th>No</th>
                          <th>Nama</th>
                          <th>NIP</th>
                          <th>Kode Tes</th>
                          <th>Batch</th>
                          <th>Total Score</th>
                          <th>Kesimpulan Akhir</th>
                          <th>Jumlah Kompetensi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="isLoadingSummary">
                          <td colspan="10" class="text-center">
                            <i class="fas fa-spinner fa-spin"></i> Loading...
                          </td>
                        </tr>
                        <tr v-else-if="tableDataSummary.length === 0">
                          <td class="text-center" colspan="99">
                            Data Tidak Tersedia
                          </td>
                        </tr>
                        <tr
                          v-else
                          v-for="(row, index) in tableDataSummary"
                          :key="index"
                        >
                          <td class="text-center">
                            {{ index + paginationSummary.from }}
                          </td>
                          <td class="text-center">{{ row.nama }}</td>
                          <td class="text-center">{{ row.nip }}</td>
                          <td class="text-center">{{ row.kode_tes }}</td>
                          <td class="text-center">{{ row.nama_batch }}</td>
                          <td class="text-center">{{ row.total_skor }}</td>
                          <td class="text-center">
                            {{ row.kesimpulan_akhir }}
                          </td>
                          <td class="text-center">
                            {{ row.jumlah_kompetensi }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <pagination
                    :pagination="paginationSummary"
                    @to-page="toPageSummary"
                  />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped></style>
